var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    wordbankWrapperBorder: borders.widthSmall,
    wordbankWrapperBorderColor: colors.contrasts.grey4570,
    wordbankWrapperBorderRadius: borders.radiusMedium,
    wordbankWrapperColor: colors.contrasts.grey1111,
    wordbankWrapperMargin: spacing.xSmall,
    printBorder: borders.widthSmall,
    printBorderColor: colors.contrasts.grey4570,
    printBorderRadius: borders.radiusMedium,
    printColor: colors.contrasts.grey1111,
    printMargin: spacing.xSmall
  };
};
export default generateComponentTheme;